import { useFocusEffect } from 'expo-router';
import { useEffectEvent, useState } from 'react';

type UseRefetchOnFocusOptions = {
  enabled?: boolean;
  refetch: () => void;
};

export default function useRefetchOnFocus({
  enabled = true,
  refetch,
}: UseRefetchOnFocusOptions) {
  const onFocus = useEffectEvent(() => {
    if (enabled) {
      refetch();
    }
  });
  const [focusEffect] = useState(() => onFocus);

  useFocusEffect(focusEffect);
}
